@switch (viewType) {
  @case (ViewType.List) {
    <a
      class="simple-btn simple-btn-md simple-btn-rounded simple-btn-dark-line"
      (click)="onToggleViewTypeClick()">
      <i class="icon-picture-alt"></i>
      <span>{{ 'forms.showAsThumbnails' | translate }}</span>
    </a>
  }
  @case (ViewType.Thumbnails) {
    <a
      class="simple-btn simple-btn-md simple-btn-rounded simple-btn-dark-line"
      (click)="onToggleViewTypeClick()">
      <i class="icon-list-1"></i>
      <span>{{ 'forms.showAsList' | translate }}</span>
    </a>
  }
}
